import axiosInstance from "src/common/axiosInstance";
import { setAgencySuccessful, setAgencyFailed } from "./reducer";
import { clearFilters } from "../../Filters/reducer";

export const setAgency:any = (agency: any, history: any, shouldNavigate?: boolean,redirectPath: string = "/analytics") => async (dispatch: any) => {
    try {
        let response;        
        const agency_data = JSON.stringify(agency);
        const agencyObject = JSON.parse(agency_data);
        response = await axiosInstance.get(`/agency-info`, {
            params: {
                agency_id: agencyObject.agency_id, // Passing agency id as a query parameter
            },
        });
        const data = await response.data;
        if (data) {
            // Clear previous agency's filter data before setting new agency
            dispatch(clearFilters());
            localStorage.setItem("agencyInfo", JSON.stringify(data));
            dispatch(setAgencySuccessful(data));
            if(shouldNavigate)
                history(redirectPath);        
        }
    } catch (error) {
        dispatch(setAgencyFailed(error))
    }
};
